import {
    REQUEST_DASHBOARD,
    RESPONSE_DASHBOARD,
    FAILURE_DASHBOARD,
    UPDATE_DASHBOAR_FILTERS,
    UPDATE_DASHBOAR_NEW_UPDATES
  } from "../../actions/types";
  
  
  const initialState = {
    isFetching: false,
    error: false,
    isInitialScreen: true,
    results: {},
    filters: {
      
    }
  };
  
  const setFetching = (state, action) => {
    return {
      ...state,
      isFetching: true,
      isInitialScreen: false
    };
  };
  
  const setFailure = (state, action) => {
    return {
      ...state,
      isFetching: false,
      error: true,
      isInitialScreen: false
  
    };
  };
  
  const setResults = (state, action) => {
    const results = action.payload.results || {};
    return {
      ...state,
      isFetching: false,
      error: false,
      results: results
    };
  };

  const setFilters = (state, action) => {
    let newFilters = action.payload.filters || {};
    return {
      ...state,
      filters: newFilters
    }
  }

  const updateNewUpdates =  (state, action) => {
    let recentUpdates = action.payload.recentUpdates || {};
    let oldRecentUpdates = state.results.recentUpdates || [];
    let results = {
      ...state.results,
      recentUpdates:[...oldRecentUpdates, ...recentUpdates]
    }

    return {
      ...state,
      results: results
    }
  }

  
  export default (state = initialState, action) => {
    switch (action.type) {
      case REQUEST_DASHBOARD:
        return setFetching(state, action);
        break;
  
      case RESPONSE_DASHBOARD:
        return setResults(state, action);
  
      case FAILURE_DASHBOARD:
        return setFailure(state, action);

      case UPDATE_DASHBOAR_FILTERS:
        return setFilters(state, action);
      
      case UPDATE_DASHBOAR_NEW_UPDATES:
        return updateNewUpdates(state, action);
  
      default:
        return state;
        break;
    }
  };

//   shortListStats: shortListStats,
//   longListStats: longListStats,
//   finalListStats: finalListStats,
//   personalListStats: personalListStats,
//   newUpdates: newUpdates
  